export const scheduleCallConfig = {
  ghlUrl: "https://api.leadconnectorhq.com/widget/booking/pvSPIagh7QDeGS6U9rxB",
  buttonLabel: "Schedule a Call",
};
